import type { InputHTMLAttributes, ReactNode } from 'react';
import { forwardRef } from 'react';

import {
  IconWrapStyled,
  InputStyled,
  InputWrapStyled,
  LabelStyled,
  RequiredSignStyled,
} from './Input.styled';

type InputPropsT = InputHTMLAttributes<HTMLInputElement> & {
  name?: string;
  label?: string | ReactNode;
  icon?: ReactNode;
  bg?: 'grey';
  isRequired?: boolean;
};

const Input = forwardRef<HTMLInputElement, InputPropsT>(
  ({ name, label, icon, bg, isRequired, ...restProps }, ref) => (
    <InputWrapStyled>
      {label && (
        <LabelStyled htmlFor={name}>
          {label}
          {isRequired && <RequiredSignStyled>&nbsp;*</RequiredSignStyled>}
        </LabelStyled>
      )}
      {icon && <IconWrapStyled>{icon}</IconWrapStyled>}
      <InputStyled id={name} name={name} ref={ref} bg={bg} {...restProps} />
    </InputWrapStyled>
  )
);

export default Input;
